<template>
  <div style="display: inline-block;">
    <span @click="show()" :id="'orderDelegate'+order.id">
      <slot></slot>
    </span>
    <el-dialog v-if="dialogFormVisible" class="el-dialog-sm" :close-on-click-modal="false" :modal="!mobiletype" :visible.sync="dialogFormVisible" width="90%" @close="init()">
      <div :class="{mobile_upload_order:mobiletype}">
        <div v-if="step==1">
          <h3 class="text-center">下单委托</h3>
          <el-form ref="form" :model="form" :rules="rules" class="dialog-form">
            <ul class="error-messages" v-if="!isEmptyErrors">
              <li v-for="error in errors">{{error[0].message}}</li>
            </ul>
            <el-form-item>
              <div style="margin-bottom:10px;">
                <el-select clearable
                filterable
                :filter-method="remoteSellerDelegateSearch"
                class="customheight_auto" style="width:100%;"
                v-model="form.buyer_account_id" placeholder="买手">
                          <el-option
                            v-for="item in buyerdelegates"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                </el-select>
                <!--<el-select class="customheight_auto" v-model="form.buyer_account_id" placeholder="买手" style="width:100%;height:50px;">
                  <el-option
                    v-for="item in buyers"
                    :key="item.single_account_id"
                    :label="item.single_username"
                    :value="item.single_account_id">
                  </el-option>
                </el-select>-->
              </div>
            </el-form-item>
            <el-form-item prop="transport_express_id">
              <el-select style="width:100%;height:50px;margin-bottom:10px;"
                          v-model="transport_express"
                          clearable
                          filterable
                          :filter-method="remotetransportSearch"
                          class="input-width customheight_auto"
                          @change="transporthandleSelect"
                          placeholder="转运公司">
                          <el-option
                            v-for="item in remoteTrasports"
                            :key="item.id"
                            :label="item.value"
                            :value="item.id"></el-option>
                        </el-select>
            </el-form-item>
            <el-form-item prop="transport_delegate">
              <!--<div style="margin-bottom:10px;display:flex;justify-content: space-between;">
                <div style="width:48%;">
                  <el-select clearable
                  filterable
                  :filter-method="remoteSellerDelegateSearch2"
                  class="customheight_auto" style="width:100%;"
                  v-model="seller_delegate" placeholder="商家发货委托人">
                            <el-option
                              v-for="item in sellerdelegates"
                              :key="item.account_id"
                              :label="item.username"
                              :value="item.account_id">
                            </el-option>
                  </el-select>
                </div>
                <div style="width:48%;">
                  <el-select filterable
                  :filter-method="remoteTransportDelegateSearch"
                  class="customheight_auto" style="width:100%;"
                  v-model="transport_delegate" placeholder="转运发货委托人">
                    <el-option
                      v-for="item in transportdelegates"
                      :key="item.account_id"
                      :label="item.username"
                      :value="item.account_id">
                    </el-option>
                  </el-select>
                </div>
              </div>-->
              <el-select filterable
                :filter-method="remoteTransportDelegateSearch"
                class="customheight_auto" style="width:100%;height:50px;margin-bottom:10px;"
                v-model="transport_delegate" placeholder="转运发货委托人">
                  <el-option
                    v-for="item in transportdelegates"
                    :key="item.account_id"
                    :label="item.username"
                    :value="item.account_id">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
              <el-button class="block nohover" type="default" @click="step++">指定地址</el-button>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button :loading="loading" style="margin-bottom:20px;" class="block" type="primary" @click="submitSkipAddress()">提交</el-button>
          </div>
        </div>
        <div v-if="step==2">
          <h3 class="text-center"><i v-if="step > 1" class="el-icon-arrow-left back" @click="step--"></i>选择地址</h3>
          <AddAddressDialog :needSave="true" style="float:right;"
                v-on:success="addAddress"
              >
                <div class="pointer">
                  <span class="add-tip"><i class="el-icon-circle-plus-outline"></i> 添加新地址</span>
                </div>
              </AddAddressDialog>
          <AddressList style="clear:both" :noNeedEdit="true" :addressId="this.form.merchant_order_shipping_address_id" v-on:changeAddress="changeAddress"></AddressList>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../../../services/api.js'
import YueDanIpt from '../../../../components/YueDanIpt'
import AddressList from '../../../publish_task/address/AddressList'
import AddAddressDialog from '../../../publish_task/address/AddAddressDialog'

let _ = require('lodash')

export default {
  name: 'UploadOrderNo',
  props: ['order', 'isSingle','mobiletype','expressList','buyers','delegates'],
  components: {
    YueDanIpt: YueDanIpt,
    AddressList,AddAddressDialog
  },
  computed: {
  },
  data () {
    return {
      step:1,
      remoteTrasports:[],
      sellerdelegates:[],
      buyerdelegates:[],
      transport_delegate:'',
      seller_delegate:'',
      transportdelegates:[],
      settings:{},
      transport_express:'',
      dialogFormVisible: false,
      isEmptyErrors: true,
      errors: null,
      form: {
        buyer_account_id: null,
        transport_express_id:null,
        merchant_order_shipping_address_id:null
      },
      account_id:this.$localStorage.get('account_id'),
      loading: false,
      rules: {
        buyer_account_id: [
          // { required: true, message: '商家订单号是必填项', trigger: 'blur' }
        ]
      },
      combinedelegates:[]
    }
  },
  methods: {
    uniqueObjects(arr) {
      const unique = new Set();
      return arr.filter((obj) => {
        const stringKey = JSON.stringify(obj);
        const found = unique.has(stringKey);
        unique.add(stringKey);
        return !found;
      });
    },
    addAddress(e){
      this.form.merchant_order_shipping_address_id=e.address_id;
      this.submit()
    },
    changeAddress(e){
      this.form.merchant_order_shipping_address_id=e.address_id;
      this.submit()
    },
    getSelectAddress(address){
      if(address.country != '中国大陆(CN)'){
        return `${address.first_name} ${address.last_name}`
      }
      else
        return `${address.last_name} ${address.first_name}`
    },
    async show () {
      this.combinedelegates=this.uniqueObjects(this.delegates.concat(this.buyers.map((i)=>{return {account_id:i.id,username:i.name}})))
      this.dialogFormVisible = true  
      if(this.order.buyer_delegate_account_id && this.order.buyer_delegate_account_id!='0'){
        this.form.buyer_account_id=this.order.buyer_delegate_account_id
      }
      if(this.order.merchant_order_shipping_address_id && this.order.merchant_order_shipping_address_id!='0'){
        this.form.merchant_order_shipping_address_id=this.order.merchant_order_shipping_address_id
      }
      //处理初始的转运公司id
      this.transport_express=''
      let old_transport_express=''
      if(this.order.transport_express_id && this.order.transport_express_id!='0'){
        old_transport_express=this.order.transport_express_id;
      }
      else if(this.order.service_type==2){
        old_transport_express=this.settings[this.order.business_id] && this.settings[this.order.business_id].transport_express?this.settings[this.order.business_id].transport_express:'';
      }
      if(old_transport_express){
          this.remotetransportSearch('',()=>{
            this.transport_express=old_transport_express
            this.form.transport_express_id=this.transport_express;
            this.transportSelect=true;
          })
      }
      if(this.form.buyer_account_id){
        let o=this.buyers.filter(i=>i.id==this.form.buyer_account_id)
        this.buyerdelegates=o
      }

      if(this.order.transport_shipping_account_id && this.order.transport_shipping_account_id!='0'){
        this.transportdelegates=this.combinedelegates.filter(i=>i.account_id==this.order.transport_shipping_account_id)
        this.transport_delegate=this.order.transport_shipping_account_id
      }
    },
    init () {
      this.form.business_order_no = null
      this.errors = null
      this.isEmptyErrors = true
    },
    async transportquerySearch(queryString, cb){
      console.log(queryString)
      let query = {
        keyword: queryString
      }
      //let res = await api.getExpressList(this,query)
      let res=this.expressList.filter((i)=>{
        return i.name.indexOf(query)>-1
      })
      let arr = []
      _.each(res,item => {
        if(item.type == '2') {
          arr.push({value:item.name,id:item.id})
        }
      })
      cb(arr)
      this.transportSelect = false
      this.form.transport_express_id = null
      this.errors = null
      this.isEmptyErrors = true
    },
    
    async remotetransportSearch(queryString,callback){
      this.remoteTrasports=[]
      /*let query = {
        keyword: queryString
      }*/
      //let res = await api.getExpressList(this,query)
      let res=this.expressList.filter((i)=>{
        return i.name.toLowerCase().indexOf(queryString.toLowerCase())>-1
      })
      _.each(res,item => {
        if(item.type == '2') {
          this.remoteTrasports.push({value:item.name,id:item.id})
          //this.form.express = item.id
        }
      })
      this.transportSelect = false
      this.form.transport_express_id = null
      this.errors = null
      this.isEmptyErrors = true
      if(callback)
          callback()
    },
    remoteSellerDelegateSearch(queryString){
      if(queryString==''){
        ;//this.buyerdelegates=[{account_id:-1,username:'暂无'}]
      }
      else{
        this.buyerdelegates=this.buyers.filter(i=>i.name.toLowerCase()==queryString.toLowerCase())
      }
    },
    remoteSellerDelegateSearch2(queryString){
      if(queryString==''){
        this.sellerdelegates=[{account_id:-1,username:'暂不委托'}]
      }
      else{
        this.sellerdelegates=this.combinedelegates.filter(i=>i.username.toLowerCase()==queryString.toLowerCase())
      }
    },
    remoteTransportDelegateSearch(queryString){
      if(queryString==''){
        this.transportdelegates=[{account_id:-1,username:'暂不委托'}]
      }
      else{
        this.transportdelegates=this.combinedelegates.filter(i=>i.username.toLowerCase()==queryString.toLowerCase())
      }
    },
    transporthandleSelect (item) {
        //this.form.transport_express_id = item.id
        this.form.transport_express_id = item
        if(!item)
          this.remoteTrasports=[]
        this.transportSelect = true
    },
    submitSkipAddress(){
      if(!this.form.buyer_account_id){
        this.isEmptyErrors = false
        this.errors = {
          business_name: [
            {message: '请指定买手'}
          ]
        }
        return
      }
      this.$refs['form'].validate((valid, errors) => {
        this.isEmptyErrors = _.isEmpty(errors)
        this.errors = errors

        if (valid) {
          this.submit()
        } else {
          return false
        }
      })
    },
    async submit() {
      let data={
              order_id: this.order.id,
              buyer_account_id: this.form.buyer_account_id,
              transport_express_id: this.form.transport_express_id,
              merchant_order_shipping_address_id:this.form.merchant_order_shipping_address_id
          }
          if(this.transport_delegate)
            data.transport_shipping_account_id=this.transport_delegate
          let res = await api.post(this, {
            path: 'order.php',
            api: 'bind_buyer_delegate',
            data: data,
            loading: 'loading'
          })
          res = res.body
          if (res.status == 'ok') {    
            /*this.order.buyer_delegate_account_id=this.form.buyer_account_id
            this.order.buyer_delegate_username =  this.buyers.find(i=>i.id==this.form.buyer_account_id).name 
            this.order.transport_express_id=this.form.transport_express_id
            this.order.transport_shipping_account_id=this.transport_delegate*/
            Object.assign(this.order, res.result);
            this.order.groupOrderLines = _.groupBy(this.order.goods_list, 'package_id')
            this.order.update_time = res.result.update_time
            this.dialogFormVisible = false  
          }       
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .dialog-form {
    padding-bottom: 20px;
  }
  .tip {
    font-size: 12px;
    color: #888888;
    line-height: 16px;
  }
  .mobile_upload_order {
    padding: 0 10px !important;
  }
  .back {
    float: left;
    color: #C0C4CC;
    font-size: 26px;
    line-height: 30px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/list/single/OrderDelegateDialog.vue